const NotificationsPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Notifications</h2>
    <div className="mb-6">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">
        Send New Notification
      </h3>
      <form className="space-y-2">
        <div>
          <label
            htmlFor="recipient"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Recipient:
          </label>
          <select
            id="recipient"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option>All Members</option>
            <option>Specific Member</option>
            <option>All Trainers</option>
            <option>Specific Batch</option>
          </select>
        </div>
        <div>
          <label
            htmlFor="subject"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Subject:
          </label>
          <input
            type="text"
            id="subject"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="messageContent"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Message:
          </label>
          <textarea
            id="messageContent"
            rows="5"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors duration-300 font-semibold"
        >
          Send Notification
        </button>
      </form>
    </div>
    <div className="mt-8">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">
        Recent Notifications
      </h3>
      <ul className="space-y-4">
        <li className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
          <p className="font-semibold text-gray-800">
            New Class Schedule for August
          </p>
          <p className="text-sm text-gray-600">
            To: All Members | Sent: 2025-07-20
          </p>
        </li>
        <li className="bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
          <p className="font-semibold text-gray-800">
            Trainer Meeting Reminder
          </p>
          <p className="text-sm text-gray-600">
            To: All Trainers | Sent: 2025-07-22
          </p>
        </li>
      </ul>
    </div>
  </div>
);

export default NotificationsPage;
